// Persist the agent/photographer referral slug a visitor arrived with so that a booking
// made later through the general /book flow is still attributed to the referrer.
const KEY = "reelty_ref";
const TTL_MS = 30 * 24 * 3600 * 1000; // 30 days

export function captureRef(slug) {
  if (!slug) return;
  try { localStorage.setItem(KEY, JSON.stringify({ slug: String(slug).toLowerCase(), at: Date.now() })); } catch {}
}

export function getRef() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { slug, at } = JSON.parse(raw);
    if (!slug || Date.now() - at > TTL_MS) { localStorage.removeItem(KEY); return null; }
    return slug;
  } catch { return null; }
}

export function clearRef() {
  try { localStorage.removeItem(KEY); } catch {}
}
